import { ConfigProvider, App } from "antd";
import { UserModalType } from "helpers/constants/users";
import ChangeUserRoleModal, { UserData } from "./ChangeUserRoleModal";
import { CreateUserModal } from "./CreateUserModal";
import ResetUserPasswordModal from "./ResetUserPasswordModal";
import UserDeleteModal from "./UserDeleteModal";
import styles from "./style.module.scss";

interface UserModalManagerProps {
  activeModal: UserModalType | null;
  onClose: () => void;
  selectedUser?: UserData | null;
  onRefresh?: () => void;
}

const UserModalManager = ({
  activeModal,
  onClose,
  selectedUser = null,
  onRefresh,
}: UserModalManagerProps) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: '"Inter", sans-serif',
        },
        components: {
          Modal: {
            titleFontSize: 18,
            titleColor: "var(--text-color-on-primary)",
            contentBg: "var(--background-surface-color-on-background)",
            paddingContentHorizontal: 16,
            paddingMD: 15,
          },
          Form: {
            itemMarginBottom: 0,
            labelColor: "var(--text-color-on-primary)",
            labelFontSize: 14,
            labelHeight: 14,
            verticalLabelPadding: "0 0 8px",
          },
          Input: {
            colorText: "var(--text-color-on-primary)",
            fontSize: 14,
            paddingBlock: 4,
            paddingInline: 12,
            controlHeight: 48,
            activeBorderColor: "var(--primary-accent-color-primary)",
            hoverBorderColor: "vavar(--primary-accent-color-primary)",
            colorTextDisabled: "var(--text-color-on-surface)",
            colorBgContainerDisabled:
              "var(--background-surface-color-background)",
          },
          Select: {
            selectorBg: "var(--background-surface-color-on-background)",
            colorText: "var(--text-color-on-primary)",
            colorBorder: "var(--background-surface-color-outline)",
            colorIcon: "var(--text-color-on-primary)",
            controlHeight: 32,
          },
        },
      }}
      form={{
        requiredMark: (label, { required }) => (
          <>
            {label}
            {required && <div className={styles.requiredMark}>*</div>}
          </>
        ),
      }}
    >
      <App>
        <CreateUserModal
          close={onClose}
          isOpen={activeModal === UserModalType.CREATE_USER}
          onRefresh={onRefresh}
        />
        <ChangeUserRoleModal
          isOpen={activeModal === UserModalType.CHANGE_ROLE}
          onClose={onClose}
          user={selectedUser}
          onRefresh={onRefresh}
        />
        <ResetUserPasswordModal
          isOpen={activeModal === UserModalType.CHANGE_PASSWORD}
          onClose={onClose}
          user={selectedUser}
        />
        <UserDeleteModal
          user={selectedUser}
          onClose={onClose}
          isOpen={activeModal === UserModalType.DELETE_USER}
          onRefresh={onRefresh}
        />
      </App>
    </ConfigProvider>
  );
};

export default UserModalManager;
